<template>
  <div>
    <div class="l-row">
    </div>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      options: {
        status: 'error'
      },
      disabled: true,
      source: {}
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      getOptions () {
        return this.options
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .form-checkbox
    margin-top: 10px
</style>



// WEBPACK FOOTER //
// Options.vue?8e9dff38